export const internalLink = groq`
    _type == "internalLink" => {
      _key,
      "slug": @.reference->slug,
      "type": @.reference->_type,
      "url": "https://yourdomain.com/" + @.reference->_type + "/" + @.reference->slug.current
    }
`

export const parents = groq`
"parent": select(
  defined(parent) => {
    "label": parent->title,
    "page": parent->{
      title,
      "slug": slug.current,
      "url": "/" + slug.current
    }
  },
  !defined(parent) => null
)
`

export const link = groq`
  _type == "link" => {
    linkType,
    url,
    label,
    "target": select(target == true => "_blank", "_self"),
    
    page->{
      title,
      'slug': slug.current,
      "url": select(
          defined(parent) => '/' + parent->slug.current + '/' + slug.current,
          _type == "article" => "/article/" + slug.current,
          _type == "page" => "/" + slug.current,
          '/' + slug.current
        )
    }
}
`

export const textLink = groq`*[_id == $ref][0] {
  title,
  'slug': slug.current,
}`

export const portableText = groq`content[] {
  ...,
  markDefs[]{
    ...,
    ${internalLink}
  }
}`

export const portableTextSimple = groq`{
  ...,
  markDefs[]{
    ...,
    ${internalLink}
  }
}`

export const media = groq`
  media {
  ...,
  image {
    ...,
    caption,
    ...asset-> {
    altText,
    ...metadata {
      lqip, // the lqip can be used for blurHashUrl or other low-quality placeholders
      ...dimensions {
        width,
        height
      },
    },
  },
  },
    
    video {
      asset-> {
        playbackId,
        assetId,
        filename,
        "duration": data.duration,
        thumbTime,
      },
    },
  }
`
export const mediaCard = groq`
  _type == "reference" => {
    'title' : @->title,
    'tag': @->tag,
    'text': @->text,
    'media': @->{
      ...${media}
    },
  }
`
export const educationCard = groq`
  _type == "reference" => {
    'theme': @->theming->handle.current,

    'sticker': @->sticker{
      ...,
          ...asset-> {
    altText,
    caption,
    ...metadata {
      lqip, // the lqip can be used for blurHashUrl or other low-quality placeholders
      ...dimensions {
        width,
        height,
      },
    },
  },
    },
    'title' : @->title,
    'text': @->text,
    'media': @->{
      ...${media},
    },
  }
`
export const specieCard = groq`
  _type == "specie" => {
    title,
    text,
    portableTextSimple[]{
      ...${portableTextSimple},
    },
    color,
    ${media}
  }
`

export const specie = groq`
   _type == "specie" => {
    "title": @->title,
    "latinName": @->latinName,
    "family": @->family,
    'text': @->text,
    'portableTextSimple': @->portableTextSimple[]{
      ...${portableTextSimple},
    },
    'color': @->color,
    'status': @->status,
    'media': @->{
      ...${media}
    }
}
`

export const tag = groq`
  _type == "reference" => {
    '_id': @->_id,
    "title": @->title,
}`

export const socialMediaCard = groq`
   _type == "reference" => {
    "title": @->title,
    'date': @->date,
    'media': @->{
      ...${media}
    },
    'callToAction': @->callToAction{
      ${link}
    },
    'tag': @->tag{
      ${tag},
    },
}
`

export const page = groq`
  _type == "reference" => {
    "title": @->title,
    'publishedAt': @->publishedAt,
    'seo': @->seo,
    'media': @->{
      ...${media}
    },
    'slug':  "/" + @->_type + "/" + @->slug.current,
    'tag': @->tag{
      ${tag},
    },
    'heroMedia': @->hero{
      ...${media}
    },
    
}`

export const tags = groq`'tags': tags[]->title`

export const seo = groq`
  'seo': {
    'title': coalesce(seo.title, title),
    'description': seo.description,
    'canonical': seo.canonical,
    'noindex': seo.noindex,
    'image': seo.image {
      _type,
      'asset': asset->{
        _ref,
        _type,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      }
    }
  }
`

export const pageDefaults = groq`
{ 
  _type,
  _createdAt,
  _updatedAt,
  title,
  'media':${media},
  'tag': tag{
      ${tag}
    },
  'seo': {
    'title': coalesce(seo.title, title),
    'description': seo.description,
    'canonical': seo.canonical,
    'noindex': seo.noindex,
    'image': seo.image {
      _type,
      'asset': asset->{
        _ref,
        _type,
        url,
        metadata {
          dimensions {
            width,
            height
          }
        }
      }
    }
  },
  "slug": select(
    defined(parent) => '/' + parent->slug.current + '/' + slug.current,
    _type == "article" => "/article/" + slug.current,
    _type == "page" => "/" + slug.current,
    _type == "frontpage" => "/",
    '/' + slug.current
  ),
  publishedAt,
  language,
}
`

export const relatedArticles = groq`
  'previous': *[_type == ^._type && _createdAt < ^._createdAt && language == ^.language] | order(_createdAt desc)[0]{
    ...${pageDefaults},
    'media': {...${media}}
  },
  'next': *[_type == ^._type && _createdAt > ^._createdAt && language == ^.language] | order(_createdAt asc)[0]{
    ...${pageDefaults},
    'media': {...${media}}
  }
`

export const partner = groq`
  _type == "reference" => {
    '_id': @->_id,
    "title": @->title,
    "logo": @->logo,
    "svgLogo": @->svgLogo,
    "url": @->url,
    "content": @->content,
}`

export const parentsRef = groq`
"parent": select(
  defined(@->parent) => {
    "label": @->parent->title,
    "page": @->parent->{
      title,
      "slug": slug.current,
      "url": "/" + slug.current
    }
  },
  !defined(@->parent) => null
)
`

export const person = groq`{
  "_id": @->_id,
  "title": @->title,
  "role": @->role,
  "media": @->profileImage,
  "email": @->email,
  "phone": @->phone,
  'allowPage': @->allowPage,
    ${parentsRef},
   "slug": select(
    defined(@->parent) => "/" + @->parent->slug.current + "/" + @->slug.current,
    !defined(@->parent) =>  "/" + @->slug.current
  )
}`

export const theme = groq`{
  '--theme-bg': bgColor.hsl,
  '--theme-fg': fgColor.hsl,
  '--theme-fg-inverted': bgColor.hsl,
}`
export const sectionTheme = groq`theming{
  ...@.reference->handle.current,  
}`